import { render, staticRenderFns } from "./EditButtonWithLink.vue?vue&type=template&id=edf6f6e8"
import script from "./EditButtonWithLink.vue?vue&type=script&lang=js"
export * from "./EditButtonWithLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports